@use "~theme/typography.scss";
@use "~theme/breakpoints.scss";

.cardContents {
  padding: 28px 24px 32px;

  @include breakpoints.desktop {
    padding-left: 32px;
    padding-right: 32px;

    width: 668px;
  }
}

.header {
  @include typography.heading3;
  margin: 0 0 8px;
}

.subhead {
  @include typography.caption;

  color: var(--black-at-75);

  display: grid;
  grid-auto-flow: column;
  grid-auto-columns: min-content 1fr;
  align-items: start;
  gap: 6px;

  margin-bottom: 24px;

  p {
    margin: 0;
  }
}

.body {
  @include typography.body;

  margin: 0 0 24px;
}

.fields {
  margin-bottom: 24px;

  @include breakpoints.desktop {
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 16px;
  }
}

.buttonContainer {
  display: flex;
}

.error {
  @include typography.body;
  color: var(--red);
  margin: 12px auto;
  text-align: center;
}

.emptyError {
  height: 14px;
  min-height: 0;
  padding: 0;

  @include breakpoints.desktop {
    display: none;
  }
}

.bottomText {
  padding: 0 40px 32px;

  @include typography.body;

  @include breakpoints.desktop {
    padding-left: 92px;
    padding-right: 92px;

    width: 668px;
  }

  align-items: center;
  text-align: center;
}

.hr {
  position: relative;
  top: 0.2em;
  border: none;
  border-top: 1px solid var(--blue-01-at-30);
}

.wrapper {
  display: grid;
  grid-template-columns: 36px 1fr;
}

.wrapperJr {
  display: grid;
  grid-template-columns: 40% 20% 40%;
  margin-top: 8px;
  margin-bottom: 8px;
}

.heading {
  @include typography.heading5;

  color: var(--blue-01);
  margin-bottom: 8px;
}

.box {
  border: 1px solid var(--blue-01-at-30);
  background: var(--blue-03-at-30);
  box-sizing: border-box;
  border-radius: 4px;
  padding: 16px 28px 16px 16px;
  margin-bottom: 32px;

  @include breakpoints.desktop {
    padding: 16px 80px 20px 16px;
  }
}

.or {
  text-align: center;
  color: var(--black-at-75);
}
